<template>
  <el-dialog
    title="Export danh sách sản phẩm"
    :visible.sync="dialogVisible"
    width="480px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div v-loading="loading">
      <p class="mb-3">Chọn loại sản phẩm cần export (các order chưa xử lý):</p>
      <el-select
        v-model="exportTypeDetail"
        class="w-100"
        filterable
        clearable
        multiple
        collapse-tags
        placeholder="Chọn phân loại chi tiết"
        :disabled="loading"
      >
        <el-option
          v-for="item in productTypeDetailOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div slot="footer" class="d-flex justify-content-end">
      <button
        type="button"
        class="btn btn-secondary font-weight-bold mr-2"
        :disabled="loading"
        @click="handleClose"
      >
        Đóng
      </button>
      <button
        type="button"
        class="btn btn-light-primary font-weight-bolder"
        :disabled="loading"
        @click="handleConfirm"
      >
        <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
        {{ loading ? "Export..." : "Xác nhận" }}
      </button>
    </div>
  </el-dialog>
</template>

<script>
import { PRODUCT_TYPE_DETAIL_OPTIONS } from "@/core/option/logisticsOption";

export default {
  name: "DialogExportLogistics",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      exportTypeDetail: [],
      productTypeDetailOptions: PRODUCT_TYPE_DETAIL_OPTIONS,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  watch: {
    visible(isOpen) {
      if (isOpen) {
        this.exportTypeDetail = [];
      }
    },
  },
  methods: {
    handleClose() {
      if (this.loading) return;
      this.dialogVisible = false;
      this.$emit("close");
    },
    handleConfirm() {
      if (!this.exportTypeDetail.length) {
        this.$message.warning("Vui lòng chọn ít nhất một loại export");
        return;
      }
      const typeNames = this.productTypeDetailOptions
        .filter((item) => this.exportTypeDetail.includes(item.id))
        .map((item) => item.name);
      this.$emit("confirm", {
        type_details: this.exportTypeDetail,
        type_names: typeNames,
      });
    },
  },
};
</script>

<style scoped>
</style>
